export const HEADERS_JSON = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

export const HEADERS_COMMON = {
  Accept: "application/json",
};

export const QUERY_KEYS = {
  REG_STEP: "REG_STEP",
  CABINET_INFORMATION: "CABINET_INFORMATION",
  CABINET_NOTIFICATIONS: "CABINET_NOTIFICATIONS",
  USER_PROFILE: "USER_PROFILE",
  PAYMENTS_HISTORY: "PAYMENTS_HISTORY",
  AGREEMENT_HISTORY: "AGREEMENT_HISTORY",
  LOAN_PURPOSE_LIST: "LOAN_PURPOSE_LIST",
  AUTH_STATUS: "AUTH_STATUS",
  LOAN_APPLICATION: "LOAN_APPLICATION",
  FETCH_NOTIFICATIONS: "FETCH_NOTIFICATIONS",
  SIGNUP_STEP: "SIGNUP_STEP",
};

export const STATUS = {
  SUCCESS: 200,
  CLIENT_ERRORS: 400,
  UNAUTHORIZED: 401,
  UNPROCESSABLE_ENTITY: 422,
  REJECTED: 444,
  UNAVAILABLE: 451,
  SERVER_ERRORS: 500,
};

export const SHORT_STALE_TIME = 1200; // 1.2 sec
